let userCartItems = '';
const itemsNotInCart = [];
var itemCount = 0;
Shopify.queue = [];

fetchCartToken();

// Function to generate and store a new UUID
function generateAndStoreUUID() {
    const uuid = generateUUID();
    localStorage.setItem('userUUID', uuid);
    return uuid;
}

// Function to generate a UUID
function generateUUID() {
    return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, c => {
        const r = Math.random() * 16 | 0;
        const v = c === 'x' ? r : (r & 0x3 | 0x8);
        return v.toString(16);
    });
}

// Function to fetch the cart token
function fetchCartToken() {
    fetch('/cart.js', { method: 'GET', headers: { 'Content-Type': 'application/json' } })
        .then(response => response.json())
        .then(cart => {
            cartGlobalToken = cart.token.split('?')[0];
            userGlobalUUID = localStorage.getItem('userUUID') || generateAndStoreUUID();
            if (customerGlobalId) {
                getUserCart(cart)
            }

        })
        .catch(error => {
            console.error('Error fetching cart token:', error);
        });
}

// Function to fetch user cart items
function getUserCart(currentCart) {
    const customerData = {
        store: storeGlobal,
        customerId: customerGlobalId,
        email: customerGlobalEmail,
        type: 'userCart'
    };

    fetch(`${backendURL}/shopify/searchDesign`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ data: customerData }),
    })
        .then(response => response.json())
        .then(data => {
            if (data.status === 200) {
                checkCartItems(data.body.data, currentCart);
            }
        })
        .catch(error => {
            console.error('Error fetching user cart:', error);
        });
}
function sortObject(obj) {
    return Object.keys(obj)
        .sort() // Sort the keys alphabetically
        .reduce((sorted, key) => {
            sorted[key] = obj[key];
            return sorted;
        }, {});
}
function removeEmptyObjKeys(obj) {
    Object.keys(obj).forEach(key => {
        if (obj[key] === '' || obj[key] === null || obj[key] === undefined) {
            delete obj[key];
        }
    });
}

function areObjectsEqual(obj1, obj2) {
    obj1 = sortObject(obj1);
    obj2 = sortObject(obj2);
    removeEmptyObjKeys(obj1);
    removeEmptyObjKeys(obj2);
    // Get all keys from both objects
    let keys1 = Object.keys(obj1).sort();
    let keys2 = Object.keys(obj2).sort();

    if (keys1.length !== keys2.length) return true;

    for (let key of keys1) {
        if (obj1[key] !== obj2[key]) {
            return true; // mismatch found
        }
    }
    return false; // all values match
}

function updateCartItem(oldLineItemKey, newItemData) {
    fetch('/cart/change.js', {
        method: 'POST',
        headers: {
            'Content-Type': 'application/json',
            'Accept': 'application/json',
        },
        body: JSON.stringify({
            id: oldLineItemKey,
            quantity: 0
        })
    })
        .then(response => response.json())
        .then(data => {
            addProdToCart(newItemData.id, 1, newItemData.properties)
        })
        .catch(error => {
            console.error('Error updating cart item:', error);
        });
}

/**
 * Function to get new product variant ID
 * @param userCartSavedItems
 */
function createUserCartBackendProduct(userCartSavedItems) {

    let itemCount = 0;

    userCartSavedItems.forEach(design => {
        let itemProperties = JSON.parse(design.selected_properties);
        itemProperties = normalizeItemProperties(itemProperties);
        itemProperties['customization reference'] = design.design_reference;

        if(itemProperties[customProperties.windingDirection] == undefined && itemProperties[customProperties.labelType] == customProperties.rollLabel){
            itemProperties[customProperties.windingDirection] = customProperties.windingNoneNeeded;
        }

        var postData = {
            "quantity": itemProperties[customProperties.numberOflabels],
            "executiontype":  itemProperties[customProperties.labelType],
            "materialType":  itemProperties[customProperties.material],
            "glueType":  itemProperties[customProperties.adhesive],
            "width":  design.width,
            "height":  design.height,
            "calculatedPrice": 0.00,
            "productId": design.product_id,
            "productSKU": itemProperties['SKU'],
            "windingDirection": itemProperties[customProperties.windingDirection] || customProperties.windingNoneNeeded,
            "voraus": itemProperties[customProperties.windingLeftRight],
        };

        console.log(postData,'----------postData****************');

        // return true;

        var baseURL = backendURL + '/shopify/createCustomP';

        $.ajax({
            url: baseURL,
            type: "POST",
            crossDomain: true,
            dataType: 'jsonp',
            data: { "data": JSON.stringify(postData) }
        }).done(function (response) {
            if (response.status == 200 && response.data.variantId !== '') {

                    // if update from the cart
                    labelDesignProps = {
                        productId: postData.productId,
                        store: document.documentElement.lang,
                        variantId: response.data.variantId,
                        customerId: customerGlobalId,
                        selectedProperties: itemProperties,
                        customerEmail: customerGlobalEmail,
                        customerName: customerGlobalFirstName,
                        token: itemProperties['customization reference'],
                        event: 'update'
                    }

                    postSavedDesign(labelDesignProps,'update');

                    shopify_push_to_queue(response.data.variantId, 1, itemProperties);
                    itemCount++;

                    if (itemCount === userCartSavedItems.length) {
                        Shopify.moveAlong();
                    }


            }
            if (response.status == 600) {
                alert(response.message)
            }

        }).fail(function (response) {
            console.error(response);
            $('.cartLoader').addClass('hide');
        });

    });

}

function normalizeItemProperties(properties) {
    const normalized = {};

    for (const [key, value] of Object.entries(properties)) {
      let newKey = key;
      let newValue = value;

      // --- Value renaming ---
      if (value === 'A4-Bogen') {
        newValue = 'Bogen';
      }

      normalized[newKey] = newValue;
    }

    return normalized;
}


function checkCartItems(savedCart, currentCart) {
    let userCartItems = currentCart.items;
    let itemsNotInCart = [];
    let newItemsToSave = [];

    //Extracts design references from the cart:
    let cartItems = currentCart.items.map(item => item.properties?.['customization reference']);
    //Iterates through saved designs:
    savedCart.forEach(savedDesign => {
        if (savedDesign.cart_item === 1 && savedDesign.order_status === 0) {

            //Checks if the saved design exists in the cart:
            let isInCart = cartItems.includes(savedDesign.design_reference);

            if (!isInCart) {
                //addToCart(savedDesign);
                itemsNotInCart.push(savedDesign);
            }
        }
    });


    // Check cart items against the saved designs
    userCartItems.forEach((item, index) => {
        let cartItemDesignReference = item.properties?.['customization reference'];
        let designDetails = '';
        let cartProperties = item.properties || {};
        let savedProperties = '';
        let itemKey = item.key;

        let isNewItem = !savedCart.some(design => {
            //cartItemDesignReference = item.properties?.['customization reference'];
            designDetails = design;
            savedProperties = JSON.parse(design.selected_properties.replace(/^\[|\]$/g, '')) || {};
            return design.design_reference === cartItemDesignReference;
        });

        // check and update cart item properties if any change found in existing cart items
        let existingItemPropertiesChange = savedCart.some(design => {

            savedProperties = JSON.parse(design.selected_properties.replace(/^\[|\]$/g, '')) || {};
            designDetails = design;
            if (design.design_reference === cartItemDesignReference) {
                return areObjectsEqual(cartProperties, savedProperties);
            }
            return false;

        });

        // If item is new (not matching the saved design properties), update the cart with latest properties
        if (existingItemPropertiesChange) {
            // if any of the properties not matching then we need to update the cart item properties only.
            // pass cusrrent current index and new props
            if (templateGlobal == 'cart') {
                openHoneyLoader();
            }
            $('#cartUpdateMessage').text('Ihr Warenkorb wird aktualisiert...');

            savedProperties = sortObject(savedProperties);
            const newItemData = {
                id: designDetails.variant_id, // product variant ID
                quantity: 1,
                properties: savedProperties
            };
            updateCartItem(itemKey, newItemData);
        }

        // if a new item found in the current cart, updating the cart token, customer details to DB
        if (isNewItem && cartItemDesignReference.length > 0) {
            newItemsToSave.push(item);
            const labelDesignProps = {
                store: storeGlobal,
                customerId: customerGlobalId || 0,
                customerEmail: customerGlobalEmail || 'GUEST',
                customerName: customerGlobalFirstName || 'GUEST',
                token: cartItemDesignReference,
                cartItem: 1,
                variantId: item.variant_id,
                event: 'update',
            };

            postSavedDesign(labelDesignProps);

        }
    });



    // Add missing saved items to the cart
    if (itemsNotInCart.length > 0) {
        if (templateGlobal == 'cart') {
            openHoneyLoader();
        }

        $('#cartUpdateMessage').text('Ihr Warenkorb wird aktualisiert...');

        createUserCartBackendProduct(itemsNotInCart);

        // let itemCount = 0;
        // itemsNotInCart.forEach(design => {
        //     let designProps = JSON.parse(design.selected_properties);
        //     designProps['customization reference'] = design.design_reference;

        //     shopify_push_to_queue(design.variant_id, 1, designProps);
        //     itemCount++;

        //     if (itemCount === itemsNotInCart.length) {
        //         Shopify.moveAlong();
        //     }
        // });
    }

}


/**
 *
 * @param variantID
 * @param quantity
 * @param properties
 */
function shopify_push_to_queue(variantID, quantity, properties) {
    Shopify.queue.push({
        variantId: variantID,
        quantity: quantity,
        properties: properties
    });
}

Shopify.moveAlong = function () {
    // If we still have requests in the queue, let's process the next one.
    if (Shopify.queue.length) {
        var request = Shopify.queue.shift();
        // pass the properties into addItem as well
        Shopify.addItem(request.variantId, request.quantity, request.properties, Shopify.moveAlong);
    }
    // If the queue is empty, we will redirect to the cart page.
    else {
        reorderCacheCheck = setInterval(function () {
            var refreshCount = 0;
            $.ajax({
                url: '/cart.js?cache=false',
                type: 'post',
                dataType: 'json',
                success: function (res) {

                    var cartTotalElements = res.items.length;
                    if (res.items != undefined) {
                        $.each(res.items, function (key, lineItem) {
                            if (lineItem.price > 0) {
                                refreshCount += 1;
                            }
                        })
                    }
                    if (refreshCount == cartTotalElements) {
                        clearInterval(reorderCacheCheck);
                        if (templateGlobal == 'cart') {
                            window.location.href = '/cart';
                        }
                    }
                }
            });

        }, 1000);

    }
};

// Create a new Shopify.addItem function that takes the 'properties' parameter
Shopify.addItem = function (id, qty, properties, callback) {
    var params = {
        quantity: qty,
        id: id
    };
    if (properties != false) {
        params.properties = properties;
    }
    $.ajax({
        type: 'POST',
        url: '/cart/add.js',
        dataType: 'json',
        data: params,
        success: function () {
            if (typeof callback === 'function') {
                callback();
            }
        },
        error: function () { }
    });
}
